<form class="small-form-field" [formGroup]="form">
  <app-category-select
    *ngIf="!disabled"
    [labelSelect]="'Selecione os motivos de recusa'"
    [labelSelected]="'Motivos da recusa'"
    [categories]="categories"
    [subCategoriesSelected]="reasons.value"
    [expandedCategoryId]="expandedCategoryId"
    (onChange)="reasonsChanged($event)"
  ></app-category-select>
  <app-autocomplete-form-reason
    class="d-block mt-16"
    formControlName="reason"
    [reasonIds]="reasonIds$"
  ></app-autocomplete-form-reason>
  <app-form-field class="mt-3 w-100" appearance="outline">
    <app-label>Mensagem da recusa (o funcionário pode ler isso)</app-label>
    <app-input
      multiline
      [rows]="5"
      resize="none"
      formControlName="message"
      [errorStateMatcher]="messageErrorMatcher"
    ></app-input>
    <app-hint *ngIf="messageLimit !== null" align="end">
      {{ message.value?.length || 0 }}/{{ messageLimit }}
    </app-hint>
    <app-error *ngIf="message.hasError('maxlength')">
      Máximo de {{ message.errors?.maxlength.requiredLength }} caracteres ({{
        message.errors?.maxlength.actualLength
      }}/{{ message.errors?.maxlength.requiredLength }})
    </app-error>
  </app-form-field>
  <app-error *ngIf="forceTouch">
    <span *ngIf="!reasons?.value?.length">
      Preencha o motivo e a mensagem para recusar o documento
    </span>
    <span *ngIf="!message?.value?.length">Preencha o campo acima</span>
  </app-error>
</form>
